/* eslint-disable */
// source: vivacity/config/perspective_transform.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var vivacity_core_point_pb = require('../../vivacity/core/point_pb.js');
goog.object.extend(proto, vivacity_core_point_pb);
goog.exportSymbol('proto.vivacity.config.CloudPerspectiveTransform', null, global);
goog.exportSymbol('proto.vivacity.config.HomographyRow', null, global);
goog.exportSymbol('proto.vivacity.config.PerspectiveTransformConfig', null, global);
goog.exportSymbol('proto.vivacity.config.PerspectiveTransformConfig.DistortionType', null, global);
goog.exportSymbol('proto.vivacity.config.PerspectiveTransformConfig.TransformationType', null, global);
goog.exportSymbol('proto.vivacity.config.PerspectiveTransformConfigByVisionProgram', null, global);
goog.exportSymbol('proto.vivacity.config.PerspectiveTransformConfigByVisionProgram.OperationType', null, global);
goog.exportSymbol('proto.vivacity.config.PerspectiveTransformPoints', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vivacity.config.PerspectiveTransformConfigByVisionProgram = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vivacity.config.PerspectiveTransformConfigByVisionProgram, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vivacity.config.PerspectiveTransformConfigByVisionProgram.displayName = 'proto.vivacity.config.PerspectiveTransformConfigByVisionProgram';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vivacity.config.PerspectiveTransformConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vivacity.config.PerspectiveTransformConfig.repeatedFields_, null);
};
goog.inherits(proto.vivacity.config.PerspectiveTransformConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vivacity.config.PerspectiveTransformConfig.displayName = 'proto.vivacity.config.PerspectiveTransformConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vivacity.config.PerspectiveTransformPoints = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vivacity.config.PerspectiveTransformPoints, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vivacity.config.PerspectiveTransformPoints.displayName = 'proto.vivacity.config.PerspectiveTransformPoints';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vivacity.config.HomographyRow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vivacity.config.HomographyRow.repeatedFields_, null);
};
goog.inherits(proto.vivacity.config.HomographyRow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vivacity.config.HomographyRow.displayName = 'proto.vivacity.config.HomographyRow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vivacity.config.CloudPerspectiveTransform = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vivacity.config.CloudPerspectiveTransform.repeatedFields_, null);
};
goog.inherits(proto.vivacity.config.CloudPerspectiveTransform, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vivacity.config.CloudPerspectiveTransform.displayName = 'proto.vivacity.config.CloudPerspectiveTransform';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vivacity.config.PerspectiveTransformConfigByVisionProgram.prototype.toObject = function(opt_includeInstance) {
  return proto.vivacity.config.PerspectiveTransformConfigByVisionProgram.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vivacity.config.PerspectiveTransformConfigByVisionProgram} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.config.PerspectiveTransformConfigByVisionProgram.toObject = function(includeInstance, msg) {
  var f, obj = {
    operationType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    configByVisionProgramMap: (f = msg.getConfigByVisionProgramMap()) ? f.toObject(includeInstance, proto.vivacity.config.PerspectiveTransformConfig.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vivacity.config.PerspectiveTransformConfigByVisionProgram}
 */
proto.vivacity.config.PerspectiveTransformConfigByVisionProgram.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vivacity.config.PerspectiveTransformConfigByVisionProgram;
  return proto.vivacity.config.PerspectiveTransformConfigByVisionProgram.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vivacity.config.PerspectiveTransformConfigByVisionProgram} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vivacity.config.PerspectiveTransformConfigByVisionProgram}
 */
proto.vivacity.config.PerspectiveTransformConfigByVisionProgram.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.vivacity.config.PerspectiveTransformConfigByVisionProgram.OperationType} */ (reader.readEnum());
      msg.setOperationType(value);
      break;
    case 2:
      var value = msg.getConfigByVisionProgramMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readUint32, jspb.BinaryReader.prototype.readMessage, proto.vivacity.config.PerspectiveTransformConfig.deserializeBinaryFromReader, 0, new proto.vivacity.config.PerspectiveTransformConfig());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vivacity.config.PerspectiveTransformConfigByVisionProgram.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vivacity.config.PerspectiveTransformConfigByVisionProgram.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vivacity.config.PerspectiveTransformConfigByVisionProgram} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.config.PerspectiveTransformConfigByVisionProgram.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperationType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getConfigByVisionProgramMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeUint32, jspb.BinaryWriter.prototype.writeMessage, proto.vivacity.config.PerspectiveTransformConfig.serializeBinaryToWriter);
  }
};


/**
 * @enum {number}
 */
proto.vivacity.config.PerspectiveTransformConfigByVisionProgram.OperationType = {
  UNKNOWN: 0,
  UPDATE: 1,
  DELETE: 2,
  SET: 3,
  CREATE: 4
};

/**
 * optional OperationType operation_type = 1;
 * @return {!proto.vivacity.config.PerspectiveTransformConfigByVisionProgram.OperationType}
 */
proto.vivacity.config.PerspectiveTransformConfigByVisionProgram.prototype.getOperationType = function() {
  return /** @type {!proto.vivacity.config.PerspectiveTransformConfigByVisionProgram.OperationType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.vivacity.config.PerspectiveTransformConfigByVisionProgram.OperationType} value
 * @return {!proto.vivacity.config.PerspectiveTransformConfigByVisionProgram} returns this
 */
proto.vivacity.config.PerspectiveTransformConfigByVisionProgram.prototype.setOperationType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * map<uint32, PerspectiveTransformConfig> config_by_vision_program = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.vivacity.config.PerspectiveTransformConfig>}
 */
proto.vivacity.config.PerspectiveTransformConfigByVisionProgram.prototype.getConfigByVisionProgramMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.vivacity.config.PerspectiveTransformConfig>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      proto.vivacity.config.PerspectiveTransformConfig));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.vivacity.config.PerspectiveTransformConfigByVisionProgram} returns this
 */
proto.vivacity.config.PerspectiveTransformConfigByVisionProgram.prototype.clearConfigByVisionProgramMap = function() {
  this.getConfigByVisionProgramMap().clear();
  return this;};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vivacity.config.PerspectiveTransformConfig.repeatedFields_ = [3,4,5,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vivacity.config.PerspectiveTransformConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.vivacity.config.PerspectiveTransformConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vivacity.config.PerspectiveTransformConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.config.PerspectiveTransformConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    transformationType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    distortionType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pointsToTransformList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    transformationPointsList: jspb.Message.toObjectList(msg.getTransformationPointsList(),
    proto.vivacity.config.PerspectiveTransformPoints.toObject, includeInstance),
    homographyMatrixList: jspb.Message.toObjectList(msg.getHomographyMatrixList(),
    proto.vivacity.config.HomographyRow.toObject, includeInstance),
    inverseTransform: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    enableGpsToCartesianTransform: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    gpsToCartesianPointsToTransformList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vivacity.config.PerspectiveTransformConfig}
 */
proto.vivacity.config.PerspectiveTransformConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vivacity.config.PerspectiveTransformConfig;
  return proto.vivacity.config.PerspectiveTransformConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vivacity.config.PerspectiveTransformConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vivacity.config.PerspectiveTransformConfig}
 */
proto.vivacity.config.PerspectiveTransformConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.vivacity.config.PerspectiveTransformConfig.TransformationType} */ (reader.readEnum());
      msg.setTransformationType(value);
      break;
    case 2:
      var value = /** @type {!proto.vivacity.config.PerspectiveTransformConfig.DistortionType} */ (reader.readEnum());
      msg.setDistortionType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addPointsToTransform(value);
      break;
    case 4:
      var value = new proto.vivacity.config.PerspectiveTransformPoints;
      reader.readMessage(value,proto.vivacity.config.PerspectiveTransformPoints.deserializeBinaryFromReader);
      msg.addTransformationPoints(value);
      break;
    case 5:
      var value = new proto.vivacity.config.HomographyRow;
      reader.readMessage(value,proto.vivacity.config.HomographyRow.deserializeBinaryFromReader);
      msg.addHomographyMatrix(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInverseTransform(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableGpsToCartesianTransform(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addGpsToCartesianPointsToTransform(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vivacity.config.PerspectiveTransformConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vivacity.config.PerspectiveTransformConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vivacity.config.PerspectiveTransformConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.config.PerspectiveTransformConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransformationType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getDistortionType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getPointsToTransformList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getTransformationPointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.vivacity.config.PerspectiveTransformPoints.serializeBinaryToWriter
    );
  }
  f = message.getHomographyMatrixList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.vivacity.config.HomographyRow.serializeBinaryToWriter
    );
  }
  f = message.getInverseTransform();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getEnableGpsToCartesianTransform();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getGpsToCartesianPointsToTransformList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.vivacity.config.PerspectiveTransformConfig.TransformationType = {
  UNKNOWN_TRANSFORMATION: 0,
  GPS: 1,
  CARTESIAN: 2
};

/**
 * @enum {number}
 */
proto.vivacity.config.PerspectiveTransformConfig.DistortionType = {
  UNKNOWN_DISTORTION: 0,
  DISTORTED: 1,
  UNDISTORTED: 2
};

/**
 * optional TransformationType transformation_type = 1;
 * @return {!proto.vivacity.config.PerspectiveTransformConfig.TransformationType}
 */
proto.vivacity.config.PerspectiveTransformConfig.prototype.getTransformationType = function() {
  return /** @type {!proto.vivacity.config.PerspectiveTransformConfig.TransformationType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.vivacity.config.PerspectiveTransformConfig.TransformationType} value
 * @return {!proto.vivacity.config.PerspectiveTransformConfig} returns this
 */
proto.vivacity.config.PerspectiveTransformConfig.prototype.setTransformationType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional DistortionType distortion_type = 2;
 * @return {!proto.vivacity.config.PerspectiveTransformConfig.DistortionType}
 */
proto.vivacity.config.PerspectiveTransformConfig.prototype.getDistortionType = function() {
  return /** @type {!proto.vivacity.config.PerspectiveTransformConfig.DistortionType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.vivacity.config.PerspectiveTransformConfig.DistortionType} value
 * @return {!proto.vivacity.config.PerspectiveTransformConfig} returns this
 */
proto.vivacity.config.PerspectiveTransformConfig.prototype.setDistortionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated string points_to_transform = 3;
 * @return {!Array<string>}
 */
proto.vivacity.config.PerspectiveTransformConfig.prototype.getPointsToTransformList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.vivacity.config.PerspectiveTransformConfig} returns this
 */
proto.vivacity.config.PerspectiveTransformConfig.prototype.setPointsToTransformList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.vivacity.config.PerspectiveTransformConfig} returns this
 */
proto.vivacity.config.PerspectiveTransformConfig.prototype.addPointsToTransform = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vivacity.config.PerspectiveTransformConfig} returns this
 */
proto.vivacity.config.PerspectiveTransformConfig.prototype.clearPointsToTransformList = function() {
  return this.setPointsToTransformList([]);
};


/**
 * repeated PerspectiveTransformPoints transformation_points = 4;
 * @return {!Array<!proto.vivacity.config.PerspectiveTransformPoints>}
 */
proto.vivacity.config.PerspectiveTransformConfig.prototype.getTransformationPointsList = function() {
  return /** @type{!Array<!proto.vivacity.config.PerspectiveTransformPoints>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vivacity.config.PerspectiveTransformPoints, 4));
};


/**
 * @param {!Array<!proto.vivacity.config.PerspectiveTransformPoints>} value
 * @return {!proto.vivacity.config.PerspectiveTransformConfig} returns this
*/
proto.vivacity.config.PerspectiveTransformConfig.prototype.setTransformationPointsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.vivacity.config.PerspectiveTransformPoints=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vivacity.config.PerspectiveTransformPoints}
 */
proto.vivacity.config.PerspectiveTransformConfig.prototype.addTransformationPoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.vivacity.config.PerspectiveTransformPoints, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vivacity.config.PerspectiveTransformConfig} returns this
 */
proto.vivacity.config.PerspectiveTransformConfig.prototype.clearTransformationPointsList = function() {
  return this.setTransformationPointsList([]);
};


/**
 * repeated HomographyRow homography_matrix = 5;
 * @return {!Array<!proto.vivacity.config.HomographyRow>}
 */
proto.vivacity.config.PerspectiveTransformConfig.prototype.getHomographyMatrixList = function() {
  return /** @type{!Array<!proto.vivacity.config.HomographyRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vivacity.config.HomographyRow, 5));
};


/**
 * @param {!Array<!proto.vivacity.config.HomographyRow>} value
 * @return {!proto.vivacity.config.PerspectiveTransformConfig} returns this
*/
proto.vivacity.config.PerspectiveTransformConfig.prototype.setHomographyMatrixList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.vivacity.config.HomographyRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vivacity.config.HomographyRow}
 */
proto.vivacity.config.PerspectiveTransformConfig.prototype.addHomographyMatrix = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.vivacity.config.HomographyRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vivacity.config.PerspectiveTransformConfig} returns this
 */
proto.vivacity.config.PerspectiveTransformConfig.prototype.clearHomographyMatrixList = function() {
  return this.setHomographyMatrixList([]);
};


/**
 * optional bool inverse_transform = 6;
 * @return {boolean}
 */
proto.vivacity.config.PerspectiveTransformConfig.prototype.getInverseTransform = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vivacity.config.PerspectiveTransformConfig} returns this
 */
proto.vivacity.config.PerspectiveTransformConfig.prototype.setInverseTransform = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool enable_gps_to_cartesian_transform = 7;
 * @return {boolean}
 */
proto.vivacity.config.PerspectiveTransformConfig.prototype.getEnableGpsToCartesianTransform = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vivacity.config.PerspectiveTransformConfig} returns this
 */
proto.vivacity.config.PerspectiveTransformConfig.prototype.setEnableGpsToCartesianTransform = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * repeated string gps_to_cartesian_points_to_transform = 8;
 * @return {!Array<string>}
 */
proto.vivacity.config.PerspectiveTransformConfig.prototype.getGpsToCartesianPointsToTransformList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.vivacity.config.PerspectiveTransformConfig} returns this
 */
proto.vivacity.config.PerspectiveTransformConfig.prototype.setGpsToCartesianPointsToTransformList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.vivacity.config.PerspectiveTransformConfig} returns this
 */
proto.vivacity.config.PerspectiveTransformConfig.prototype.addGpsToCartesianPointsToTransform = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vivacity.config.PerspectiveTransformConfig} returns this
 */
proto.vivacity.config.PerspectiveTransformConfig.prototype.clearGpsToCartesianPointsToTransformList = function() {
  return this.setGpsToCartesianPointsToTransformList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vivacity.config.PerspectiveTransformPoints.prototype.toObject = function(opt_includeInstance) {
  return proto.vivacity.config.PerspectiveTransformPoints.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vivacity.config.PerspectiveTransformPoints} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.config.PerspectiveTransformPoints.toObject = function(includeInstance, msg) {
  var f, obj = {
    imageSpace: (f = msg.getImageSpace()) && vivacity_core_point_pb.PointI.toObject(includeInstance, f),
    transformedSpace: (f = msg.getTransformedSpace()) && vivacity_core_point_pb.PointF.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vivacity.config.PerspectiveTransformPoints}
 */
proto.vivacity.config.PerspectiveTransformPoints.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vivacity.config.PerspectiveTransformPoints;
  return proto.vivacity.config.PerspectiveTransformPoints.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vivacity.config.PerspectiveTransformPoints} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vivacity.config.PerspectiveTransformPoints}
 */
proto.vivacity.config.PerspectiveTransformPoints.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new vivacity_core_point_pb.PointI;
      reader.readMessage(value,vivacity_core_point_pb.PointI.deserializeBinaryFromReader);
      msg.setImageSpace(value);
      break;
    case 2:
      var value = new vivacity_core_point_pb.PointF;
      reader.readMessage(value,vivacity_core_point_pb.PointF.deserializeBinaryFromReader);
      msg.setTransformedSpace(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vivacity.config.PerspectiveTransformPoints.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vivacity.config.PerspectiveTransformPoints.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vivacity.config.PerspectiveTransformPoints} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.config.PerspectiveTransformPoints.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImageSpace();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      vivacity_core_point_pb.PointI.serializeBinaryToWriter
    );
  }
  f = message.getTransformedSpace();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      vivacity_core_point_pb.PointF.serializeBinaryToWriter
    );
  }
};


/**
 * optional vivacity.core.PointI image_space = 1;
 * @return {?proto.vivacity.core.PointI}
 */
proto.vivacity.config.PerspectiveTransformPoints.prototype.getImageSpace = function() {
  return /** @type{?proto.vivacity.core.PointI} */ (
    jspb.Message.getWrapperField(this, vivacity_core_point_pb.PointI, 1));
};


/**
 * @param {?proto.vivacity.core.PointI|undefined} value
 * @return {!proto.vivacity.config.PerspectiveTransformPoints} returns this
*/
proto.vivacity.config.PerspectiveTransformPoints.prototype.setImageSpace = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vivacity.config.PerspectiveTransformPoints} returns this
 */
proto.vivacity.config.PerspectiveTransformPoints.prototype.clearImageSpace = function() {
  return this.setImageSpace(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vivacity.config.PerspectiveTransformPoints.prototype.hasImageSpace = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional vivacity.core.PointF transformed_space = 2;
 * @return {?proto.vivacity.core.PointF}
 */
proto.vivacity.config.PerspectiveTransformPoints.prototype.getTransformedSpace = function() {
  return /** @type{?proto.vivacity.core.PointF} */ (
    jspb.Message.getWrapperField(this, vivacity_core_point_pb.PointF, 2));
};


/**
 * @param {?proto.vivacity.core.PointF|undefined} value
 * @return {!proto.vivacity.config.PerspectiveTransformPoints} returns this
*/
proto.vivacity.config.PerspectiveTransformPoints.prototype.setTransformedSpace = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vivacity.config.PerspectiveTransformPoints} returns this
 */
proto.vivacity.config.PerspectiveTransformPoints.prototype.clearTransformedSpace = function() {
  return this.setTransformedSpace(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vivacity.config.PerspectiveTransformPoints.prototype.hasTransformedSpace = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vivacity.config.HomographyRow.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vivacity.config.HomographyRow.prototype.toObject = function(opt_includeInstance) {
  return proto.vivacity.config.HomographyRow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vivacity.config.HomographyRow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.config.HomographyRow.toObject = function(includeInstance, msg) {
  var f, obj = {
    homographyValueList: (f = jspb.Message.getRepeatedFloatingPointField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vivacity.config.HomographyRow}
 */
proto.vivacity.config.HomographyRow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vivacity.config.HomographyRow;
  return proto.vivacity.config.HomographyRow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vivacity.config.HomographyRow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vivacity.config.HomographyRow}
 */
proto.vivacity.config.HomographyRow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedDouble() : [reader.readDouble()]);
      for (var i = 0; i < values.length; i++) {
        msg.addHomographyValue(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vivacity.config.HomographyRow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vivacity.config.HomographyRow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vivacity.config.HomographyRow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.config.HomographyRow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHomographyValueList();
  if (f.length > 0) {
    writer.writePackedDouble(
      1,
      f
    );
  }
};


/**
 * repeated double homography_value = 1;
 * @return {!Array<number>}
 */
proto.vivacity.config.HomographyRow.prototype.getHomographyValueList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedFloatingPointField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.vivacity.config.HomographyRow} returns this
 */
proto.vivacity.config.HomographyRow.prototype.setHomographyValueList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.vivacity.config.HomographyRow} returns this
 */
proto.vivacity.config.HomographyRow.prototype.addHomographyValue = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vivacity.config.HomographyRow} returns this
 */
proto.vivacity.config.HomographyRow.prototype.clearHomographyValueList = function() {
  return this.setHomographyValueList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vivacity.config.CloudPerspectiveTransform.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vivacity.config.CloudPerspectiveTransform.prototype.toObject = function(opt_includeInstance) {
  return proto.vivacity.config.CloudPerspectiveTransform.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vivacity.config.CloudPerspectiveTransform} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.config.CloudPerspectiveTransform.toObject = function(includeInstance, msg) {
  var f, obj = {
    perspectiveTransformConfig: (f = msg.getPerspectiveTransformConfig()) && proto.vivacity.config.PerspectiveTransformConfig.toObject(includeInstance, f),
    pointsList: jspb.Message.toObjectList(msg.getPointsList(),
    vivacity_core_point_pb.Point.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vivacity.config.CloudPerspectiveTransform}
 */
proto.vivacity.config.CloudPerspectiveTransform.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vivacity.config.CloudPerspectiveTransform;
  return proto.vivacity.config.CloudPerspectiveTransform.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vivacity.config.CloudPerspectiveTransform} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vivacity.config.CloudPerspectiveTransform}
 */
proto.vivacity.config.CloudPerspectiveTransform.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vivacity.config.PerspectiveTransformConfig;
      reader.readMessage(value,proto.vivacity.config.PerspectiveTransformConfig.deserializeBinaryFromReader);
      msg.setPerspectiveTransformConfig(value);
      break;
    case 2:
      var value = new vivacity_core_point_pb.Point;
      reader.readMessage(value,vivacity_core_point_pb.Point.deserializeBinaryFromReader);
      msg.addPoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vivacity.config.CloudPerspectiveTransform.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vivacity.config.CloudPerspectiveTransform.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vivacity.config.CloudPerspectiveTransform} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.config.CloudPerspectiveTransform.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPerspectiveTransformConfig();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vivacity.config.PerspectiveTransformConfig.serializeBinaryToWriter
    );
  }
  f = message.getPointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      vivacity_core_point_pb.Point.serializeBinaryToWriter
    );
  }
};


/**
 * optional PerspectiveTransformConfig perspective_transform_config = 1;
 * @return {?proto.vivacity.config.PerspectiveTransformConfig}
 */
proto.vivacity.config.CloudPerspectiveTransform.prototype.getPerspectiveTransformConfig = function() {
  return /** @type{?proto.vivacity.config.PerspectiveTransformConfig} */ (
    jspb.Message.getWrapperField(this, proto.vivacity.config.PerspectiveTransformConfig, 1));
};


/**
 * @param {?proto.vivacity.config.PerspectiveTransformConfig|undefined} value
 * @return {!proto.vivacity.config.CloudPerspectiveTransform} returns this
*/
proto.vivacity.config.CloudPerspectiveTransform.prototype.setPerspectiveTransformConfig = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vivacity.config.CloudPerspectiveTransform} returns this
 */
proto.vivacity.config.CloudPerspectiveTransform.prototype.clearPerspectiveTransformConfig = function() {
  return this.setPerspectiveTransformConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vivacity.config.CloudPerspectiveTransform.prototype.hasPerspectiveTransformConfig = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated vivacity.core.Point points = 2;
 * @return {!Array<!proto.vivacity.core.Point>}
 */
proto.vivacity.config.CloudPerspectiveTransform.prototype.getPointsList = function() {
  return /** @type{!Array<!proto.vivacity.core.Point>} */ (
    jspb.Message.getRepeatedWrapperField(this, vivacity_core_point_pb.Point, 2));
};


/**
 * @param {!Array<!proto.vivacity.core.Point>} value
 * @return {!proto.vivacity.config.CloudPerspectiveTransform} returns this
*/
proto.vivacity.config.CloudPerspectiveTransform.prototype.setPointsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.vivacity.core.Point=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vivacity.core.Point}
 */
proto.vivacity.config.CloudPerspectiveTransform.prototype.addPoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.vivacity.core.Point, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vivacity.config.CloudPerspectiveTransform} returns this
 */
proto.vivacity.config.CloudPerspectiveTransform.prototype.clearPointsList = function() {
  return this.setPointsList([]);
};


goog.object.extend(exports, proto.vivacity.config);
